import { GsFormSchema } from '../../../components';
import { BASIC_SCHEMA_FIELDS } from '../basics';
import { buttonSchemaFields } from '../basics/button-fields.schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the reservation component form.
 * Defines the fields to display for the form.
 */
export const RESERVATION_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.reservation.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
